// Gemeinsame Werte für Micro-Animationen im Dashboard. Neue Animationen nehmen
// diese Tokens statt eigener Zahlen, damit sich alles gleich anfühlt.
// Reduzierte Bewegung regelt die globale MotionConfig in src/index.js.

// Sekunden, wie framer-motion sie erwartet
export const DURATION = {
  fast: 0.15,
  base: 0.2,
  slow: 0.3
}

export const EASE = {
  standard: [0.2, 0, 0, 1],
  out: [0, 0, 0.2, 1]
}

export const SPRING = {
  // kurz und straff, für Icons und kleine Bestätigungen
  snappy: { type: 'spring', stiffness: 500, damping: 30 }
}

export const VARIANTS = {
  fade: {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 }
  },
  fadeUp: {
    initial: { opacity: 0, y: 8 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -8 }
  },
  scaleIn: {
    initial: { opacity: 0, scale: 0.5 },
    animate: { opacity: 1, scale: 1 },
    exit: { opacity: 0, scale: 0.5 }
  }
}
